const mobileInternetPlansContentWrapperStyle = () => ({
	accordionContentWrapper: {
		'& #package-MOBILE_INTERNET_PLANS > div:last-of-type p': {
			maxWidth: 325,
		},
	},
});

export default mobileInternetPlansContentWrapperStyle;
